import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/login/login.vue';
import Registry from './views/registry/registry.vue';
import ReporteIndividual from './views/reporte-individual/reporte-individual.vue';
import ReporteComparativo from './views/reporte-comparativo/reporte-comparativo.vue';
import SupportComponent from './views/support/support.component.vue';
import SupportDetailComponent from './views/support-detail/support-detail.component.vue';
import CreateSupportComponent from './views/create-support/create-support.component.vue';
import EditSupportComponent from './views/edit-support/edit-support.component.vue';
import SupportInactiveComponent from './views/support-inactive/support-inactive.component.vue';
import ReportersComponent from './views/reporters/reporters.component.vue';
import CreateReportersComponent from './views/create-reporters/create-reporters.component.vue';
import EditReportersComponent from './views/edit-reporters/edit-reporters.component.vue';
import ReportersDetailComponent from './views/reporters-detail/reporters-detail.component.vue';
import AdminsListComponent from './views/admins-list/admins-list.component.vue';
import CreateAdminsComponent from './views/create-admins/create-admins.component.vue';
import EditAdminsComponent from './views/edit-admins/edit-admins.component.vue';
import AdminDetailComponent from './views/admin-detail/admin-detail.component.vue';
import AdminsInactiveComponent from './views/admins-inactive/admins-inactive.component.vue';
import CompanyComponent from './views/company/company.component.vue';
import CreateCompanyComponent from './views/create-company/create-company.component.vue';
import EditCompanyComponent from './views/edit-company/edit-company.component.vue';
import CompaniesDetailComponent from './views/company-detail/company-detail.component.vue';
import CompaniesInactiveComponent from './views/company-inactive/company-inactive.component.vue';
import QuestionsComponent from './views/question/question.component.vue';
import CreateQuestionsComponent from './views/create-question/create-question.component.vue';
import EditQuestionsComponent from './views/edit-question/edit-question.component.vue';
import QuestionDetailComponent from './views/question-detail/question-detail.component.vue';
import QuestionsInactiveComponent from './views/question-inactive/question-inactive.component.vue';
import EvaluatedComponent from './views/evaluated/evaluated.component.vue';
import CreateEvaluatedComponent from './views/create-evaluated/create-evaluated.component.vue';
import EditEvaluatedComponent from './views/edit-evaluated/edit-evaluated.component.vue';
import EvaluatedDetailComponent from './views/evaluated-detail/evaluated-detail.component.vue';
import EvaluatedInactiveComponent from './views/evaluated-inactive/evaluated-inactive.component.vue';
import SurveyComponent from './views/survey/survey.component.vue';
import CreateSurveyComponent from './views/create-survey/create-survey.component.vue';
import EditSurveyComponent from './views/edit-survey/edit-survey.component.vue';
import SurveyDetailComponent from './views/survey-detail/survey-detail.component.vue';
import SurveyInactiveComponent from './views/survey-inactive/survey-inactive.component.vue';
import RolesComponent from './views/roles/roles.component.vue';
import CreateRolesComponent from './views/create-roles/create-roles.component.vue';
import EditRolesComponent from './views/edit-roles/edit-roles.component.vue';
import RolesDetailComponent from './views/role-detail/role-detail.component.vue';
import RolesInactiveComponent from './views/roles-inactive/roles-inactive.component.vue';
import BusinessComponent from './views/business/business.component.vue';
import CreateBusinessComponent from './views/create-business/create-business.component.vue';
import EditBusinessComponent from './views/edit-business/edit-business.component.vue';
import BusinessDetailComponent from './views/business-detail/business-detail.component.vue';
import BusinessInactiveComponent from './views/business-inactive/business-inactive.component.vue';
import SkillComponent from './views/skill/skill.component.vue';
import CreateSkillComponent from './views/create-skill/create-skill.component.vue';
import EditSkillComponent from './views/edit-skill/edit-skill.component.vue';
import SkillDetailComponent from './views/skill-detail/skill-detail.component.vue';
import SkillInactiveComponent from './views/skill-inactive/skill-inactive.component.vue';
import SectionComponent from './views/section/section.component.vue';
import CreateSectionComponent from './views/create-section/create-section.component.vue';
import EditSectionComponent from './views/edit-section/edit-section.component.vue';
import SectionDetailComponent from './views/section-detail/section-detail.component.vue';
import SectionInactiveComponent from './views/section-inactive/section-inactive.component.vue';
import ResourcesComponent from './views/resources/resources.component.vue';
import CreateResourcesComponent from './views/create-resources/create-resources.component.vue';
import EditResourcesComponent from './views/edit-resources/edit-resources.component.vue';
import ResourcesDetailComponent from './views/resources-detail/resources-detail.component.vue';
import ResourcesInactiveComponent from './views/resources-inactive/resources-inactive.component.vue';
import ProfileComponent from './views/profile/profile.component.vue';
import CreateProfileComponent from './views/create-profile/create-profile.component.vue';
import EditProfileComponent from './views/edit-profile/edit-profile.component.vue';
import ProfileDetailComponent from './views/profile-detail/profile-detail.component.vue';
import ProfileInactiveComponent from './views/profile-inactive/profile-inactive.component.vue';
import JobComponent from './views/job/job.component.vue';
import CreateJobComponent from './views/create-job/create-job.component.vue';
import EditJobComponent from './views/edit-job/edit-job.component.vue';
import JobDetailComponent from './views/job-detail/job-detail.component.vue';
import JobInactiveComponent from './views/job-inactive/job-inactive.component.vue';
import ReportComponent from './views/report/report.component.vue';
import ReportDetailComponent from './views/report-detail/report-detail.component.vue';
import TablePercentileComponent from './views/table-percentile/table-percentile.component.vue';
import PrivacyComponent from './views/privacy/privacy.component.vue';
import ConditionsComponent from './views/conditions/conditions.component.vue';
import ActComponent from "@/views/act/act.component";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/new',
      name: 'login',
      component: Login,
    },
    {
      path: '/recover',
      name: 'recover',
      component: Login,
    },
    {
      path: '/',
      name: 'new',
      component: Login,
    },
    {
      path: '/registry',
      name: 'registry',
      component: Registry,
    },
    {
      path: '/act/:id',
      name: 'act',
      component: ActComponent,
    },
    {
      path: '/single-report/:id',
      name: 'single-individual',
      component: ReporteIndividual,
    },
    {
      path: '/vs-report/:id/profile/:id',
      name: 'vs-comparativo',
      component: ReporteComparativo,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: PrivacyComponent,
    },
    {
      path: '/conditions',
      name: 'conditions',
      component: ConditionsComponent,
    },
    {
      path: '/reporters',
      name: 'reporters',
      component: ReportersComponent,
    },
    {
      path: '/reporters/create',
      name: 'reporters-create',
      component: CreateReportersComponent,
    },
    {
      path: '/reporters/edit/:user_id',
      name: 'reporters-edit',
      component: EditReportersComponent,
    },
    {
      path: '/reporters/detail/:user_id',
      name: 'reporters-detail',
      component: ReportersDetailComponent,
    },
    {
      path: '/reporters/inactive',
      name: 'admins-inactive',
      component: AdminsInactiveComponent,
    },
    {
      path: '/admins',
      name: 'admins',
      component: AdminsListComponent,
    },
    {
      path: '/admins/create',
      name: 'admins-create',
      component: CreateAdminsComponent,
    },
    {
      path: '/admins/edit/:user_id',
      name: 'admins-edit',
      component: EditAdminsComponent,
    },
    {
      path: '/admins/detail/:user_id',
      name: 'admins-detail',
      component: AdminDetailComponent,
    },
    {
      path: '/admins/inactive',
      name: 'admins-inactive',
      component: AdminsInactiveComponent,
    },
    {
      path: '/roles',
      name: 'roles',
      component: RolesComponent,
    },
    {
      path: '/roles/create',
      name: 'roles-create',
      component: CreateRolesComponent,
    },
    {
      path: '/roles/edit/:idRole',
      name: 'roles-edit',
      component: EditRolesComponent,
    },
    {
      path: '/roles/detail/:idRole',
      name: 'roles-detail',
      component: RolesDetailComponent,
    },
    {
      path: '/roles/inactive',
      name: 'roles-inactive',
      component: RolesInactiveComponent,
    },
    //companies
    {
      path: '/companies/',
      name: 'companies',
      component: CompanyComponent,
    },
    {
      path: '/companies/create',
      name: 'companies-create',
      component: CreateCompanyComponent,
    },
    {
      path: '/companies/:company_id/admins/create',
      name: 'companies-create',
      component: CreateAdminsComponent,
    },
    {
      path: '/companies/edit/:company_id',
      name: 'companies-edit',
      component: EditCompanyComponent,
    },
    {
      path: '/companies/detail/:company_id',
      name: 'companies-detail',
      component: CompaniesDetailComponent,
    },
    {
      path: '/companies/inactive',
      name: 'companies-inactive',
      component: CompaniesInactiveComponent,
    },
    {
      path: '/business',
      name: 'business',
      component: BusinessComponent,
    },
    {
      path: '/business/create',
      name: 'business-create',
      component: CreateBusinessComponent,
    },
    {
      path: '/business/edit/:idBusiness',
      name: 'business-edit',
      component: EditBusinessComponent,
    },
    {
      path: '/business/detail/:idBusiness',
      name: 'business-detail',
      component: BusinessDetailComponent,
    },
    {
      path: '/business/inactive',
      name: 'business-inactive',
      component: BusinessInactiveComponent,
    },
    //survey
    {
      path: '/survey/',
      name: 'survey',
      component: SurveyComponent,
    },
    {
      path: '/survey/create',
      name: 'survey-create',
      component: CreateSurveyComponent,
    },
    {
      path: '/survey/edit/:idSurvey',
      name: 'survey-edit',
      component: EditSurveyComponent,
    },
    {
      path: '/survey/detail/:idSurvey',
      name: 'survey-detail',
      component: SurveyDetailComponent,
    },
    {
      path: '/survey/inactive',
      name: 'survey-inactive',
      component: SurveyInactiveComponent,
    },
    {
      path: '/survey/:idSurvey/section/create',
      name: 'survey-create',
      component: CreateSectionComponent,
    },
    {
      path: '/questions/',
      name: 'questions',
      component: QuestionsComponent,
    },
    {
      path: '/question/create',
      name: 'question-create',
      component: CreateQuestionsComponent,
    },
    {
      path: '/question/edit/:idQuestion',
      name: 'question-edit',
      component: EditQuestionsComponent,
    },
    {
      path: '/question/detail/:idQuestion',
      name: 'question-detail',
      component: QuestionDetailComponent,
    },
    {
      path: '/question/inactive',
      name: 'question-inactive',
      component: QuestionsInactiveComponent,
    },
    {
      path: '/resource',
      name: 'resource',
      component: ResourcesComponent,
    },
    {
      path: '/resource/create',
      name: 'resource-create',
      component: CreateResourcesComponent,
    },
    {
      path: '/resource/edit/:resourceId',
      name: 'resource-edit',
      component: EditResourcesComponent,
    },
    {
      path: '/resource/detail/:resourceId',
      name: 'resource-detail',
      component: ResourcesDetailComponent,
    },
    {
      path: '/resource/inactive',
      name: 'resource-inactive',
      component: ResourcesInactiveComponent,
    },
    {
      path: '/section',
      name: 'section',
      component: SectionComponent,
    },
    {
      path: '/section/create',
      name: 'section-create',
      component: CreateSectionComponent,
    },
    {
      path: '/section/edit/:idSection',
      name: 'section-edit',
      component: EditSectionComponent,
    },
    {
      path: '/section/detail/:idSection',
      name: 'section-detail',
      component: SectionDetailComponent,
    },
    {
      path: '/section/inactive',
      name: 'section-inactive',
      component: SectionInactiveComponent,
    },
    {
      path: '/section/:idSection/question/create',
      name: 'section-create',
      component: CreateQuestionsComponent,
    },
    {
      path: '/survey/:idSurvey/section/:idSection/question/create',
      name: 'question-create',
      component: CreateQuestionsComponent,
    },
    {
      path: '/survey/:idSurvey/section/:idSection/question/create',
      name: 'section-create',
      component: CreateQuestionsComponent,
    },
    {
      path: '/skill',
      name: 'skill',
      component: SkillComponent,
    },
    {
      path: '/skill/create',
      name: 'skill-create',
      component: CreateSkillComponent,
    },
    {
      path: '/skill/edit/:idSkill',
      name: 'skill-edit',
      component: EditSkillComponent,
    },
    {
      path: '/skill/detail/:idSkill',
      name: 'skill-detail',
      component: SkillDetailComponent,
    },
    {
      path: '/skill/inactive',
      name: 'skill-inactive',
      component: SkillInactiveComponent,
    },
    {
      path: '/table/percentile',
      name: 'table-percentile',
      component: TablePercentileComponent,
    },
    //evaluated
    {
      path: '/evaluated/',
      name: 'evaluated',
      component: EvaluatedComponent,
    },
    {
      path: '/evaluated/create',
      name: 'evaluated-create',
      component: CreateEvaluatedComponent,
    },
    {
      path: '/evaluated/edit/:user_id',
      name: 'evaluated-edit',
      component: EditEvaluatedComponent,
    },
    {
      path: '/evaluated/detail/:user_id',
      name: 'evaluated-detail',
      component: EvaluatedDetailComponent,
    },
    {
      path: '/evaluated/inactive',
      name: 'evaluated-inactive',
      component: EvaluatedInactiveComponent,
    },
    {
      path: '/profile/',
      name: 'profile',
      component: ProfileComponent,
    },
    {
      path: '/profile/create',
      name: 'profile-create',
      component: CreateProfileComponent,
    },
    {
      path: '/profile/edit/:profileId',
      name: 'profile-edit',
      component: EditProfileComponent,
    },
    {
      path: '/profile/detail/:profileId',
      name: 'profile-detail',
      component: ProfileDetailComponent,
    },
    {
      path: '/profile/inactive',
      name: 'profile-inactive',
      component: ProfileInactiveComponent,
    },
    {
      path: '/job',
      name: 'job',
      component: JobComponent,
    },
    {
      path: '/job/create',
      name: 'job-create',
      component: CreateJobComponent,
    },
    {
      path: '/job/edit/:idJob',
      name: 'job-edit',
      component: EditJobComponent,
    },
    {
      path: '/job/detail/:idJob',
      name: 'job-detail',
      component: JobDetailComponent,
    },
    {
      path: '/job/inactive',
      name: 'job-inactive',
      component: JobInactiveComponent,
    },
    //support
    {
      path: '/support',
      name: 'support',
      component: SupportComponent,
    },
    {
      path: '/support/create',
      name: 'support-create',
      component: CreateSupportComponent,
    },
    {
      path: '/support/edit/:supportId',
      name: 'support-edit',
      component: EditSupportComponent,
    },
    {
      path: '/support/detail/:supportId',
      name: 'support-detail',
      component: SupportDetailComponent,
    },
    {
      path: '/support/inactive',
      name: 'support-inactive',
      component: SupportInactiveComponent,
    },
  ],
});
